<template>
    <aside class="menu">
        <template v-for="item in links">
            <p class="menu-label" v-if="$auth.check(item.auth)">
                {{ item.label }}
            </p>
            <ul class="menu-list" v-if="item.children.length">
                <template v-for="child in item.children">
                    <template v-if="child.children.length">
                        <li v-for="childn in child.children" v-if="$auth.check(childn.auth)">
                            <template v-if="childn.children.length">
                                <router-link :to="childn.route" :exact="childn.exact">
                                    <span>{{ childn.label }}</span>
                                </router-link>
                                <ul>
                                    <li v-for="childm in childn.children" v-if="$auth.check(childm.auth)">
                                        <router-link :to="childm.route" :exact="childm.exact">
                                            {{ childm.label }}
                                        </router-link>
                                    </li>
                                </ul>
                            </template>

                            <router-link v-else :to="childn.route" :exact="childn.exact">
                                <span>{{ childn.label }}</span>
                            </router-link>
                        </li>
                    </template>
                    <template v-else>
                        <li v-if="$auth.check(child.auth)">
                            <router-link :to="child.route" :exact="child.exact">
                                {{ child.label }}
                            </router-link>
                        </li>
                    </template>
                </template>

            </ul>

        </template>
    </aside>
</template>

<script>
    import catalogs from '../../data/catalogs';

    export default {
        name: "MainMenu",
        data() {
            return {
                subscription: {},
                links: [
                    {
                        label: 'Inicio',
                        auth: ['root', 'admin', 'super', 'user', 'guest', 'ivr_worker'],
                        children: [
                            {
                                label: 'Inicio',
                                route: {name: 'Home'},
                                auth: ['root', 'admin', 'super', 'user', 'guest', 'ivr_worker'],
                                exact: true,
                                children: []
                            },
                        ]
                    },
                    {
                        label: 'Administración',
                        auth: ['root', 'admin', 'super'],
                        children: [
                            {
                                label: 'Inicio',
                                route: {name: 'Home'},
                                auth: ['root', 'admin', 'super'],
                                exact: true,
                                children: [
                                    {
                                        label: 'Usuarios',
                                        route: {name: 'User'},
                                        auth: ['root', 'admin', 'super'],
                                        exact: false,
                                        children: [
                                            {
                                                label: 'Agregar Usuario',
                                                route: {name: 'CreateUser'},
                                                auth: ['root', 'admin', 'super'],
                                                exact: true,
                                                children: []
                                            },
                                        ]
                                    },
                                    {
                                        label: 'Ivr',
                                        route: 'Ivr',
                                        auth: ['root', 'admin', 'super'],
                                        exact: false,
                                        children: [
                                            {
                                                label: 'Departamentos',
                                                route: {name: 'Provider'},
                                                auth: ['root'],
                                                exact: true,
                                                children: []
                                            },
                                            {
                                                label: 'Reportes',
                                                route: {name: 'Report'},
                                                auth: ['root', 'admin', 'super'],
                                                exact: true,
                                                children: []
                                            },
                                        ]
                                    },
                                ]
                            },
                        ]
                    },
                    {
                        label: 'Configuraciones',
                        auth: ['root', 'admin', 'super', 'user', 'guest', 'ivr_worker'],
                        children: [
                            {
                                label: 'Perfil',
                                route: {name: 'Profile'},
                                auth: ['root', 'admin', 'super', 'user', 'guest', 'ivr_worker'],
                                exact: true,
                                children: []
                            },
                        ]
                    }
                ]
            }
        },
        created() {

          //  console.log(this.$auth.check("user"));
           // let enterprise = this.$auth.user().enterprise || {};
           //this.subscription = enterprise.subscription || {};

        },
        methods: {}
    }
</script>

<style lang="scss">

</style>
